export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 获取节点间重叠区域
 *
 * @author Sfeer
 * @param source 来源节点
 * @param target 目标节点
 * @return {number}
 */
export function getXOverRange(source, target) {
  const aa = [source.x, source.x + source.w, target.x, target.x + target.w]
  aa.sort((a, b) => a - b)
  return aa[1] / 2 + aa[2] / 2
}

/**
 * 获取节点间重叠区域
 *
 * @author Sfeer
 * @param source 来源节点
 * @param target 目标节点
 * @return {number}
 */
export function getYOverRange(source, target) {
  const aa = [source.y, source.y + source.h, target.y, target.y + target.h]
  aa.sort((a, b) => a - b)
  return aa[1] / 2 + aa[2] / 2
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {
  }
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function randomString(len = 16, chars = 'abcdefghijklmnopqrstuvwxyz') {
  let val = ''
  for (let i = 0; i < len; i++) {
    val += chars[Math.floor(Math.random() * chars.length)]
  }
  return val
}

//获取文件名（不含后缀）
export function getFileShortName(fileName) {
  const pIndex = fileName.lastIndexOf('.'); // 取到文件名开始到最后一个点的长度
  return fileName.substring(0, pIndex); // 截取
}

//获取文件名后缀
export function getFileExtName(fileName) {
  const pIndex = fileName.lastIndexOf('.'); // 取到文件名开始到最后一个点的长度
  const fileNameLen = fileName.length; // 取到文件名长度
  return fileName.substring(pIndex + 1, fileNameLen); // 截取
}

//实现trim功能
export function myTrim(x) {
  if (x === undefined || x === null || x === ''){
    return x
  }
  return x.replace(/^\s+|\s+$/gm,'');
}

//三条件判空
export function isEmpty(s) {
  if (s === null || s === undefined || '' === myTrim(s)){
    return true
  }
  return false
}